(ns frontend.ui.component.lp-portal.report.overview.recent-development-figures.view
  (:require
   [common.time :as c-time]
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.text-content.view :as text-content]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.component.dynamic-table.view :as dynamic-table]))

(defn recent-development-card
  [{:keys [rich-content rich-content-path
           rich-content-completed-at rich-content-completed-path]
    :as   recent-development-text}
   recent-development
   {:keys [edit-mode? show-draft? save-text] :as props}]
  [card
   {:title "Recent development"}
   [text-content/free-text-with-modal
    {:html-content      rich-content
     :completed-at      rich-content-completed-at
     :completed-path    rich-content-completed-path
     :complete-changed! (when (and edit-mode?
                                   (fn? save-text))
                          (fn [new-content completed?]
                            (save-text rich-content-path
                                       new-content
                                       rich-content-completed-path
                                       (if completed?
                                         ""
                                         (str (c-time/now-millis))))))
     :show-draft?       show-draft?
     :can-edit?         edit-mode?
     :on-change         (when (and edit-mode?
                                   (fn? save-text))
                          #(save-text rich-content-path %))}]
   [:<>
    [dynamic-table/dynamic-stack (:figures recent-development)]
    (text-content/optional-footnote recent-development props)]])

(defn recent-development-with-highlights-card
  [{:keys [rich-content rich-content-path
           rich-content-completed-at rich-content-completed-path]
    :as   recent-development-text}
   recent-development
   {:keys [edit-mode? show-draft? save-text title] :as props}]
  [grid/row
   {}
   [grid/column
    {}
    [card
     {:title      "Recent development"
      :left-split 6}
     [text-content/free-text-with-modal
      {:html-content      rich-content
       :completed-at      rich-content-completed-at
       :completed-path    rich-content-completed-path
       :complete-changed! (when (and edit-mode?
                                     (fn? save-text))
                            (fn [new-content completed?]
                              (save-text rich-content-path
                                         new-content
                                         rich-content-completed-path
                                         (if completed?
                                           ""
                                           (str (c-time/now-millis))))))
       :show-draft?       show-draft?
       :can-edit?         edit-mode?
       :on-change         (when (and edit-mode?
                                     (fn? save-text))
                            #(save-text rich-content-path %))}]]]
   [grid/column
    {}
    [card
     {:title (or title "Highlights")}
     [:<>
      [dynamic-table/dynamic-table
       {:parsed-data (:figures recent-development)
        :sub-heading-color (theme/color [:dynamic-table :heading-row :bg])
        :odd-row-background-color (theme/color [:dynamic-table :odd-row :bg])
        :even-row-background-color (theme/color [:dynamic-table :even-row :bg])}]
      (text-content/optional-footnote recent-development props)]]]])
